import ComercialInterfaceHeader from "@/components/comercial/ComercialInterfaceHeader";
import {Trans, useTranslation} from "react-i18next";
import {Box, Typography} from "@mui/material";
import WorkingScaleSelector from "@/components/comercial/WorkingScaleSelector";

export const StoreWorkingScale = ({ intervalMinutes, setIntervalMinutes, workingHours, setWorkingHours }: any) => {
    const { t } = useTranslation();

    const setDayTime = (day: string) => (value: string[]) => {
        setWorkingHours((prev: any) => ({ ...prev, [day]: value }));
    };

    return (
        <>
            <ComercialInterfaceHeader title={t("storePage.management.add.workScaleTitle")} />
            <Box>
                <Typography>
                    <Trans i18nKey="storePage.management.add.workScale.defaultText">
                        Horário padrão de funcionamento: <b>7:00-11:00</b> e <b>13:00-17:00</b>.
                    </Trans>
                </Typography>
                <Typography>{t("storePage.management.add.workScale.customizeText")}</Typography>
            </Box>
            <Box>
                <WorkingScaleSelector
                    intervalMinutes={intervalMinutes}
                    setIntervalMinutes={setIntervalMinutes}
                    timeMonday={workingHours.timeMonday} setTimeMonday={setDayTime("timeMonday")}
                    timeTuesday={workingHours.timeTuesday} setTimeTuesday={setDayTime("timeTuesday")}
                    timeWednesday={workingHours.timeWednesday} setTimeWednesday={setDayTime("timeWednesday")}
                    timeThursday={workingHours.timeThursday} setTimeThursday={setDayTime("timeThursday")}
                    timeFriday={workingHours.timeFriday} setTimeFriday={setDayTime("timeFriday")}
                    timeSaturday={workingHours.timeSaturday} setTimeSaturday={setDayTime("timeSaturday")}
                    timeSunday={workingHours.timeSunday} setTimeSunday={setDayTime("timeSunday")}
                />
            </Box>
        </>
    );
};